import { scriptarioEnContent } from "@/content/landing/scriptario-en";
import { scriptarioDeContent } from "@/content/landing/scriptario-de";
import { scriptarioEsContent } from "@/content/landing/scriptario-es";
import { scriptarioItContent } from "@/content/landing/scriptario-it";
import { scriptarioPtBrContent } from "@/content/landing/scriptario-pt-br";
import { normalizeScriptarioLocale } from "@/config/locales";

const contentByLocale = {
  de: scriptarioDeContent,
  en: scriptarioEnContent,
  es: scriptarioEsContent,
  "pt-br": scriptarioPtBrContent,
  it: scriptarioItContent,
};

const locale = normalizeScriptarioLocale(process.env.NEXT_PUBLIC_LOCALE);

export const landingContent = contentByLocale[locale];
